import { render, staticRenderFns } from "./KeysBlock.vue?vue&type=template&id=056ba0b6"
import script from "./keysBlock.ts?vue&type=script&lang=js&external"
export * from "./keysBlock.ts?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports